/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastModifyBy: pein
 * @LastModifyTime: 2025-02-13 22:27:49
 */

import React from 'react'
import { Tag } from 'antd'
import { useFilterMemberHistory } from '../../../../app/hooks/useFilterMemberHistory'
import { SelectedDepartment } from '../index'
import { DepartmentMemberV2, DepartmentV2 } from '../../../../global'
import produce from 'immer'
import {
  findChildrenDepartmentIDs,
  findUserIDsInDepartment
} from '../../../department/componentsV2'
import sensors from '../../../../utils/sensors'

interface FilteredHistoryProps {
  selectedDepartments: SelectedDepartment[]
  setSelectedDepartments: (selectedDepartments: SelectedDepartment[]) => void
  selectedDepartmentUsers: DepartmentMemberV2[]
  setSelectedDepartmentUsers: (
    selectedDepartmentUsers: DepartmentMemberV2[]
  ) => void
}

const FilteredHistory = (props: FilteredHistoryProps) => {
  const {
    selectedDepartments,
    setSelectedDepartments,
    selectedDepartmentUsers,
    setSelectedDepartmentUsers
  } = props
  const { history: searchHistory } = useFilterMemberHistory()

  // const handleUseDepartment = (department: DepartmentV2) => {
  //   const selected = selectedDepartments.some(
  //     (selectedDepartment) => selectedDepartment.id === department.id
  //   )
  //   //选中部门
  //   //检查已选择部门列表中是否包含子孙级节点，如果存在则过滤掉子孙级节点，只保留当前部门节点
  //   setSelectedDepartments(
  //     produce(selectedDepartments, (draft) => {
  //       const departmentChildIDs = findChildrenDepartmentIDs(department)
  //       const mDraft = draft.filter(
  //         (selectedDepartment) =>
  //           !departmentChildIDs.includes(selectedDepartment.id)
  //       )
  //       if (!selected) {
  //         mDraft.push({
  //           id: department.id,
  //           name: department.name,
  //           num: department.num
  //         })
  //       }
  //       return mDraft
  //     })
  //   )
  //   //检查已选择部门成员列表中是否包含此部门下的成员，如果存在则过滤掉，只保留当前部门节点
  //   setSelectedDepartmentUsers(
  //     produce(selectedDepartmentUsers, (draft) => {
  //       const userIDs = findUserIDsInDepartment(department)
  //       const mDraft = draft.filter(
  //         (selectedDepartmentUser) =>
  //           !userIDs.includes(selectedDepartmentUser.userID)
  //       )
  //       return mDraft
  //     })
  //   )
  // }

  const handleUseDepartmentV2 = (
    department: SelectedDepartment,
    index: number
  ) => {
    const selected = selectedDepartments.some(
      (selectedDepartment) => selectedDepartment.id === department.id
    )
    if (!selected) {
      setSelectedDepartments(
        produce(selectedDepartments, (draft) => {
          draft.push(department)
        })
      )
    }
    sensors.track('web_workgroup_filter_member_page_click', {
      clickItem: 'historyRecord',
      pagePath: window.location.pathname,
      clickContent: department.name,
      historyRecordRank: index + 1
    })
  }

  // const handleUseUser = (user: DepartmentMemberV2) => {
  //   const selected = selectedDepartmentUsers.some(
  //     (selectedUser) => selectedUser.userID === user.userID
  //   )
  //   setSelectedDepartmentUsers(
  //     produce(selectedDepartmentUsers, (draft) => {
  //       if (!selected) {
  //         draft.push(user)
  //       }
  //     })
  //   )
  // }

  const handleUseUserV2 = (user: DepartmentMemberV2, index: number) => {
    const selected = selectedDepartmentUsers.some(
      (selectedUser) => selectedUser.userID === user.userID
    )
    if (!selected) {
      setSelectedDepartmentUsers(
        produce(selectedDepartmentUsers, (draft) => {
          draft.push(user)
        })
      )
    }
    sensors.track('web_workgroup_filter_member_page_click', {
      clickItem: 'historyRecord',
      pagePath: window.location.pathname,
      clickContent: user.name,
      historyRecordRank: index + 1
    })
  }

  return (
    <div className="search-history-wrap">
      {searchHistory?.map((item, index) => {
        return (
          <Tag
            key={index}
            onClick={() => {
              if ('userID' in item) {
                console.log('handleUseUser')
                handleUseUserV2(item, index)
              } else {
                console.log('handleUseDepartment')
                handleUseDepartmentV2(item, index)
              }
            }}
          >
            {item.name}
          </Tag>
        )
      })}
    </div>
  )
}

export default FilteredHistory
